import { Empresa } from "./Empresa";

export class EmpresaUpdateModel 
{
    RepercutirList : any[]
    Empresa: Empresa
    IsParentControlsUpdated : boolean
}